import React, { useEffect } from "react";
import PageContainer from "../../../layout/page-container/PageContainer";
import Head from "../../../layout/head/Head";
import AuthFooter from "../AuthFooter";
import {
  Block,
  BlockContent,
  BlockDes,
  BlockHead,
  BlockTitle,
  Button,
  Icon,
  PreviewCard,
} from "../../../components/Component";
import { Spinner, FormGroup, Alert } from "reactstrap";
import { Link } from "react-router-dom";
import useForm from "./useForm";
import validate from "./ValidationInfo";
import Logo from "../../../img/Logo.png";
import "../auth-theme.css";

const FormSignup = ({ submitForm }) => {
  const [passState, setPassState] = React.useState(false);
  const [passState1, setPassState1] = React.useState(false);

  const {
    handleSubmit,
    errors,
    loading,
    errorVal,
    companydropdown,
    handleChangeEmail,
    handleChangeUserid,
    handleChangeName,
    handleChangeContact,
    handleChangeAddress,
    handleChangePassword,
    handleChangeConfirmPassword,
    email,
    userid,
    name,
    contact,
    address,
    password,
    company,
    companycode,
    confirm_password,
  } = useForm(submitForm, validate);

  useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();
  }, []);

  return (
    <React.Fragment>
      <Head title="Register" />
      <PageContainer>
        <div className="nz-auth">
          <Block className="nk-block-middle nk-auth-body wide-xs">
            <div className="brand-logo pb-4 text-center">
              <Link to={`${process.env.PUBLIC_URL}/`} className="logo-link">
                <img src={Logo} width="40" height="40" style={{ margin: "10px" }} alt="logo" />
                <span
                  style={{
                    color: "#228B22",
                    fontSize: "22px",
                    fontWeight: "bold",
                    borderColor: "#000000",
                    marginTop: "20px",
                  }}
                >
                  Noser
                </span>
              </Link>
            </div>
            <PreviewCard className="card-bordered" bodyClass="card-inner-lg">
              <BlockHead>
                <BlockContent>
                  <BlockTitle tag="h4">Register</BlockTitle>
                  <BlockDes>
                    <p>Create New Noser Account</p>
                  </BlockDes>
                </BlockContent>
              </BlockHead>
              {errorVal && (
                <div className="mb-3">
                  <Alert color="danger" className="alert-icon">
                    {" "}
                    <Icon name="alert-circle" /> Unable to register{" "}
                  </Alert>
                </div>
              )}
              <form className="is-alter" onSubmit={handleSubmit}>
                <FormGroup>
                  <div className="form-label-group">
                    <label className="form-label" htmlFor="email">
                      Email Address
                    </label>
                  </div>
                  <div className="form-control-wrap">
                    <input
                      type="text"
                      name="email"
                      className="form-control-m form-control"
                      placeholder="Enter Your Email Address"
                      autoComplete="off"
                      value={email}
                      onChange={handleChangeEmail}
                    />
                    {errors.email && <p className="invalid">{errors.email}</p>}
                  </div>
                </FormGroup>
                <FormGroup>
                  <div className="form-label-group">
                    <label className="form-label" htmlFor="username">
                      User ID
                    </label>
                  </div>
                  <div className="form-control-wrap">
                    <input
                      type="text"
                      name="userid"
                      className="form-control-m form-control"
                      placeholder="Enter your User ID"
                      autoComplete="off"
                      value={userid}
                      onChange={handleChangeUserid}
                    />
                    {errors.userid && <p className="invalid">{errors.userid}</p>}
                  </div>
                </FormGroup>
                <FormGroup>
                  <label className="form-label" htmlFor="name">
                    Name
                  </label>
                  <div className="form-control-wrap">
                    <input
                      type="text"
                      name="name"
                      placeholder="Enter Your Name"
                      className="form-control-m form-control"
                      autoComplete="off"
                      value={name}
                      onChange={handleChangeName}
                    />
                    {errors.name && <p className="invalid">{errors.name}</p>}
                  </div>
                </FormGroup>
                <FormGroup>
                  <label className="form-label" htmlFor="company">
                    Company
                  </label>
                  <div className="form-control-wrap">
                    <input
                      type="text"
                      name="company"
                      placeholder="Enter Your Company"
                      className="form-control-m form-control"
                      autoComplete="off"
                      value={company}
                      onChange={companydropdown}
                    />
                    {errors.company && <p className="invalid">{errors.company}</p>}
                  </div>
                </FormGroup>
                <FormGroup>
                  <label className="form-label" htmlFor="companycode">
                    Company Code
                  </label>
                  <div className="form-control-wrap">
                    <input
                      type="text"
                      name="companycode"
                      placeholder="Enter Your Company Code"
                      className="form-control-m form-control"
                      autoComplete="off"
                      value={companycode}
                    />
                    {errors.companycode && <p className="invalid">{errors.companycode}</p>}
                  </div>
                </FormGroup>
                <FormGroup>
                  <label className="form-label" htmlFor="contact">
                    Contact
                  </label>
                  <div className="form-control-wrap">
                    <input
                      type="text"
                      name="contact"
                      placeholder="Enter Your Contact Number"
                      className="form-control-m form-control"
                      autoComplete="off"
                      value={contact}
                      onChange={handleChangeContact}
                    />
                    {errors.contact && <p className="invalid">{errors.contact}</p>}
                  </div>
                </FormGroup>
                <FormGroup>
                  <label className="form-label" htmlFor="address">
                    Address
                  </label>
                  <div className="form-control-wrap">
                    <input
                      type="text"
                      name="address"
                      placeholder="Enter Your Address"
                      className="form-control-m form-control"
                      autoComplete="off"
                      value={address}
                      onChange={handleChangeAddress}
                    />
                    {errors.address && <p className="invalid">{errors.address}</p>}
                  </div>
                </FormGroup>
                <FormGroup>
                  <div className="form-label-group">
                    <label className="form-label" htmlFor="password">
                      Password
                    </label>
                  </div>
                  <div className="form-control-wrap">
                    <a
                      href="#password"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setPassState(!passState);
                      }}
                      className={`form-icon lg form-icon-right passcode-switch ${passState ? "is-hidden" : "is-shown"}`}
                    >
                      <Icon name="eye" className="passcode-icon icon-show"></Icon>
                      <Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
                    </a>
                    <input
                      type={passState ? "text" : "password"}
                      name="password"
                      placeholder="Enter Your Password"
                      className={`form-control-m form-control ${passState ? "is-hidden" : "is-shown"}`}
                      value={password}
                      onChange={handleChangePassword}
                    />
                    {errors.password && <span className="invalid">{errors.password}</span>}
                  </div>
                </FormGroup>
                <FormGroup>
                  <div className="form-label-group">
                    <label className="form-label" htmlFor="confirm_password">
                      Confirm Password
                    </label>
                  </div>
                  <div className="form-control-wrap">
                    <a
                      href="#confirm_password"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setPassState1(!passState1);
                      }}
                      className={`form-icon lg form-icon-right passcode-switch ${passState1 ? "is-hidden" : "is-shown"}`}
                    >
                      <Icon name="eye" className="passcode-icon icon-show"></Icon>
                      <Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
                    </a>
                    <input
                      type={passState1 ? "text" : "password"}
                      name="confirm_password"
                      placeholder="Enter Your Confirm Password"
                      className={`form-control-m form-control ${passState1 ? "is-hidden" : "is-shown"}`}
                      value={confirm_password}
                      onChange={handleChangeConfirmPassword}
                    />
                    {errors.confirm_password && <span className="invalid">{errors.confirm_password}</span>}
                  </div>
                </FormGroup>
                <FormGroup>
                  <Button type="submit" color="primary" size="lg" className="btn-block">
                    {loading ? <Spinner size="sm" color="light" /> : "Register"}
                  </Button>
                </FormGroup>
              </form>
              <div className="form-note-s2 text-center pt-4">
                {" "}
                Already have an account?{" "}
                <Link to={`${process.env.PUBLIC_URL}/auth-login`}>
                  <strong>Sign in instead</strong>
                </Link>
              </div>
              <div className="text-center pt-4 pb-3">
                <h6 className="overline-title overline-title-sap">
                  <span>OR</span>
                </h6>
              </div>
              <ul className="nav justify-center gx-8">
                <li className="nav-item">
                  <a className="nav-link" href="#socials" onClick={(ev) => ev.preventDefault()}>
                    Facebook
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#socials" onClick={(ev) => ev.preventDefault()}>
                    Google
                  </a>
                </li>
              </ul>
            </PreviewCard>
          </Block>
          <AuthFooter />
        </div>
      </PageContainer>
    </React.Fragment>
  );
};

export default FormSignup;
